declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export function sendEvent({ name, category, label, value }) {
  if ('gtag' in window) {
    console.log('sendEvent', { name, category, label, value });
    window.gtag('event', name, {
      category,
      label,
      value,
    });
  }
}
